import { h, render } from 'preact';
import AdLoader from './utils/ad-loader';
import RelatedStories from './components/related-stories';
import select from './utils/select';
import selectAll from './utils/select-all';
import './utils/trackers';
//import './utils/ga-scroll-depth';

const annotationNavBtns = selectAll('.js-nav-annotation');

annotationNavBtns.forEach((btn) => {
  const id = btn.getAttribute('href');
  const parentEl = select(id).parentNode.parentNode;

  btn.addEventListener('click', (e) => {
    e.preventDefault();

    window.scrollTo(0, parentEl.getBoundingClientRect().top + window.pageYOffset - 15);
  });
});

render(<RelatedStories tag="subject-bathroom-bill" />, document.getElementById('related-stories-container'));

const adLoader = new AdLoader();
adLoader.init();



// WEBPACK FOOTER //
// ./main.js